import React from 'react';
import MetaTags from '../components/MetaTags';
import { getHomepageSchema } from '../utils/schemaGenerator';
import AuditionCategoryRow from '../components/AuditionCategoryRow';
import JourneyCTA from '../components/JourneyCTA';
import InstantAIScoring from '../components/InstantAIScoring';
import AuditionTypes from '../components/AuditionTypes';
import TestimonialAndDirectors from '../components/TestimonialAndDirectors';
import '../App.css';
import BannerSlider from '../components/BannerSlider';

const HomePage = () => {
  const homepageSchema = getHomepageSchema();

  const pageMeta = {
    title: "Acting Auditions in India | Bollywood Casting Calls | BookMyAudition",
    description: "Find the latest acting auditions in India and casting calls for films, web series, television, theatre and advertisements on BookMyAudition.",
    keywords: "acting auditions in India, auditions near me, latest auditions in India, upcoming auditions in India, casting calls India, acting casting calls, auditions for actors, BookMyAudition, Bollywood auditions, web series auditions, TV auditions, theatre auditions, ad film auditions",
    imageUrl: "https://web.bookmyaudition.com/social_logo.jpg", 
    url: "https://web.bookmyaudition.com/" 
  };

  return (
    <>
      <MetaTags
        title={pageMeta.title}
        description={pageMeta.description}
        keywords={pageMeta.keywords}
        url={pageMeta.url}
        imageUrl={pageMeta.imageUrl}
        schema={homepageSchema}
      />
      <main className="main-container-custom">
        <h1 className="visually-hidden" style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', border: '0' }}>
          Latest Acting Auditions in India - Bollywood, Web Series & TV
        </h1>
        <BannerSlider />
        <AuditionCategoryRow/>
        <AuditionTypes/>
        <InstantAIScoring/>
        <TestimonialAndDirectors />
        <JourneyCTA />
      </main>
    </>
  );
};

export default HomePage;